var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvaEmailFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 3.33331H4.16663C3.50358 3.33331 2.8677 3.59671 2.39886 4.06555C1.93002 4.53439 1.66663 5.17027 1.66663 5.83331V14.1666C1.66663 14.8297 1.93002 15.4656 2.39886 15.9344C2.8677 16.4033 3.50358 16.6666 4.16663 16.6666H15.8333C16.4963 16.6666 17.1322 16.4033 17.6011 15.9344C18.0699 15.4656 18.3333 14.8297 18.3333 14.1666V5.83331C18.3333 5.17027 18.0699 4.53439 17.6011 4.06555C17.1322 3.59671 16.4963 3.33331 15.8333 3.33331ZM15.8333 4.99998L10.4166 8.72498C10.2899 8.79812 10.1462 8.83663 9.99996 8.83663C9.85368 8.83663 9.70998 8.79812 9.58329 8.72498L4.16663 4.99998H15.8333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaEmailFill);
export default __webpack_public_path__ + "static/media/eva_email-fill.62448e1f8952f32c839b8df6be2c1d0c.svg";
export { ForwardRef as ReactComponent };